import moment from "moment/moment"; 
import { CloseButtonIcon } from "../../../SVGConstants";
import { APIURL } from "../../../../services/axiosServices/ApiEndPoints";

function UpgradeChangeRequestModal(props) {
  const data = props.upgradeChangeRequestDataInfo;
  let reqType = props.reqType;

  if (!data) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-y-auto">
    <div className="bg-white rounded w-[900px] max-h-[90vh] overflow-y-auto">
      <div className="px-7 pt-5 flex justify-between items-center">
          <h2 className="text-3xl font-semibold"></h2>
          <button
            className="h-7 w-7 flex items-center justify-center text-[#757575] hover:text-[#3a3a3a] rounded-full border-2 border-[#757575]"
            onClick={() => props.setIsModalOpen(false)}>
            <CloseButtonIcon />
          </button>
      </div>
        <div className="px-14 pb-14 pt-2">
          <div className="grid grid-cols-12 gap-6 w-full">
            <div className="xl:col-span-12 lg:col-span-12 col-span-12">
              <div className="overflow-x-auto">
                {/* Membership Upgrade */}

                {reqType == "Upgrade Membership" && (
                  <div>
                    <h3 className="text-2xl font-semibold mb-5 border-b py-3">Membership Upgrade Request</h3>
                    <div className="grid grid-cols-2 gap-8">
                      {/* OLD */}
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Previous Details</h4>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1">Membership Type</label>
                            <input disabled value={data.currentMembershipType ? data.currentMembershipType : "-"} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Years Of Cumulative Experiences in Logistics Service</label>
                            <input disabled value={data.ceoCurrentExp ? data.ceoCurrentExp : "-"} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">ACRA Biz File:</label>
                            <button
                            className="text-sm text-[#c00000] font-semibold tracking-normal underline text-left "
                            onClick={() => window.open(APIURL + "Common/GetPDF?type=ACRA&&fileName=" + data.existingACRABizFilePathMembershipUpgrade, '_blank')}> 
                           {data.existingACRABizFilePathMembershipUpgrade}
                          </button>
                          </div>
                        </div>
                      </div>


                      {/* NEW */}
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Current Details</h4>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1">Membership Type</label>
                            <input disabled value={data.newMembershipType ? data.newMembershipType : "-"} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Years Of Cumulative Experiences in Logistics Service</label>
                            <input disabled value={data.ceoNewExp ? data.ceoNewExp : "-"} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">ACRA Biz File: </label>
                           <button
                            className="text-sm text-[#c00000] font-semibold tracking-normal underline text-left"
                            onClick={() => window.open(APIURL + "Common/GetPDF?type=ACRA&&fileName=" + data.newACRABizFilePath, '_blank')}> 
                           {data.newACRABizFilePath}
                          </button>
                          </div>
                        </div>  
                      </div>
                    </div>
                  </div>
                )}

                {/* Change Information */}
                {( reqType == "Change Company Name") && (
                  <div>
                    <h3 className="text-2xl font-semibold mb-5 border-b py-3">Company Name Change Request</h3>
                    <div className="grid grid-cols-2 gap-8">

                      {/* OLD */}
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Previous Details</h4>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1">Company Name</label>
                            <input disabled value={data.oldCompanyName ? data.oldCompanyName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">ACRA Biz File: </label>
                            <button
                              className="text-sm text-[#c00000] font-semibold tracking-normal underline text-left"
                              onClick={() => window.open(APIURL + "Common/GetPDF?type=ACRA&&fileName=" + data.existingACRABizFilePathChangeinfo, '_blank')}
                            >
                            {data.existingACRABizFilePathChangeinfo}
                            </button>
                            </div>
                        </div>
                      </div>

                      {/* NEW */} 
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Current Details</h4>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1">Company Name</label>
                            <input disabled value={data.newCompanyName ? data.newCompanyName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">ACRA Biz File:</label>
                            <button
                              className="text-sm text-[#c00000] font-semibold tracking-normal underline text-left"
                              onClick={() => window.open(APIURL + "Common/GetPDF?type=ACRA&&fileName=" + data.acraBizFilePath, '_blank')}
                            >
                            {data.acraBizFilePath}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                )}


                {(reqType == "Change Registered Address" ) && (
                  <div>
                    <h3 className="text-2xl font-semibold mb-5 border-b py-3">Registered Address Change Request</h3>
                    <div className="grid grid-cols-2 gap-8">

                      {/* OLD */}
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Previous Details</h4>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1">Unit Number & Building Name</label>
                            <input disabled value={data.oldBuildingName ? data.oldBuildingName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Country</label>
                            <input disabled value={data.oldCountry ? data.oldCountry:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                            <div className="pl-0.5 flex register-desc pb-0.5">
                                <input
                                    id="unitNumber"
                                    name="unitNumber"
                                    type="checkbox"
                                    className="cursor-pointer check-box-custom"
                                    checked={
                                      data.oldNoUnitNumber ? true : false
                                    }
                                    disabled = {true}
                                  />
                                <label className=" pl-2 text-sm font-medium">
                                No Unit Number
                                </label>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Postal Code</label>
                            <input disabled value={data.oldPostalCode ? data.oldPostalCode:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Block No & Street Name</label>
                            <input disabled value={data.oldStreetName ? data.oldStreetName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">ACRA Biz File: </label>
                            <button
                              className="text-sm text-[#c00000] font-semibold tracking-normal underline text-left"
                              onClick={() => window.open(APIURL + "Common/GetPDF?type=ACRA&&fileName=" + data.existingACRABizFilePathChangeinfo, '_blank')}
                            >
                            {data.existingACRABizFilePathChangeinfo}
                            </button>
                            </div>
                        </div>
                      </div>

                      {/* NEW */} 
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Current Details</h4>
                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium mb-1">Unit Number & Building Name</label>
                            <input disabled value={data.newBuildingName ? data.newBuildingName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Country</label>
                            <input disabled value={data.newCountry ? data.newCountry:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div className="pl-0.5 flex register-desc pb-0.5">
                                <input
                                    id="unitNumber"
                                    name="unitNumber"
                                    type="checkbox"
                                    className="cursor-pointer check-box-custom"
                                    checked={
                                      data.newNoUnitNumber ? true : false
                                    }
                                    disabled = {true}
                                  />
                                <label className=" pl-2 text-sm font-medium">
                                No Unit Number
                                </label>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Postal Code</label>
                            <input disabled value={data.newPostalCode ? data.newPostalCode:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Block No & Street Name</label>
                            <input disabled value={data.newStreetName ? data.newStreetName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">ACRA Biz File:</label>
                            <button
                              className="text-sm text-[#c00000] font-semibold tracking-normal underline text-left"
                              onClick={() => window.open(APIURL + "Common/GetPDF?type=ACRA&&fileName=" + data.acraBizFilePath, '_blank')}
                            >
                            {data.acraBizFilePath}
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Termination Request */}
                {(reqType =="Membership Termination" || reqType == "MTO Termination") && (
                  <div>
                    <h3 className="text-2xl font-semibold mb-5 border-b py-3">{reqType == "Membership Termination" ? "Membership Termination Request" : "MTO Termination Request"}</h3>
                    <div className="space-y-4">
                      <div>
                      <label className="block text-sm font-medium mb-1">Reason</label>
                      <textarea disabled value={data.terminationReason ? data.terminationReason : '-'} className="signup-text-area w-full border bg-gray-100" name="reason"rows="5" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Selected Termination Date</label>
                        <input disabled value={data.terminationDate? moment(data.terminationDate).format("DD/MM/YYYY"):'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                      </div>
                      <>
                      <div className="pl-0.5 flex register-desc pb-0.5">
                      <input
                        id=""
                        name="isApproved"
                        type="checkbox"
                        className="cursor-pointer check-box-custom"
                        checked={
                          data.isApproved ? true : false
                        }
                        disabled = {true}
                      />
                      <label className=" pl-2 text-sm font-medium">
                        Is Approved
                      </label>
                    </div>
                      {data.isApproved &&(
                      <div>
                      <label className="block text-sm font-medium mb-1">Approval Date</label>
                      <input disabled value={data.approvalDate? moment(data.approvalDate).format("DD/MM/YYYY"):'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                    </div>
                      )}
                      </>
                    </div>
                  </div>
                )}

                {/* Change Key Position */}
                {reqType =="Change Key Position" && (
                  <div>
                    <h3 className="text-xl font-semibold mb-5 border-b py-3">Change Key Position</h3>
                    <div className="grid grid-cols-2 gap-8">
                   {/* OLD */}
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Previous Details</h4>
                        <div className="space-y-4">
                            <div>
                              <label className="flex text-sm font-medium mb-1">First Name</label>
                              <div className="flex">
                                <span className="border border-[#757575] border-r-0 px-4 py-3 bg-[#e9e9ea] text-[#757575] text-sm flex items-center whitespace-nowrap">
                                  {data.oldTitle ? data.oldTitle : '-'}
                                </span>
                                <div className="flex-1">
                                  <input
                                    disabled
                                    value={data.oldFirstName ? data.oldFirstName : '-'}
                                    className="w-full border border-[#757575] px-4 py-3 bg-[#e9e9ea] text-[#757575] text-sm"
                                  />
                                </div>
                              </div>
                            </div>
                            <div>
                            <label className="block text-sm font-medium mb-1">Last Name</label>
                            <input disabled value={data.oldLastName? data.oldLastName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Email Address</label>
                            <input disabled value={data.oldEmailAddress? data.oldEmailAddress:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>  
                          <div>
                            <label className="block text-sm font-medium mb-1">Bussiness Mobile</label>
                            <input disabled value={data.oldBussinessMobile? data.oldBussinessMobile :'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Office DID</label>
                            <input disabled value={data.oldOfficeDID? data.oldOfficeDID:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Job Position</label>
                            <input disabled value={data.oldDesignation? data.oldDesignation:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Years Of Cumulative Experiences in Logistics Service </label>
                            <input disabled value={data.oldExperienceYears? data.oldExperienceYears:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">Subscribed to Email Circulars</label>
                            {data.oldEmailSubscription && data.oldEmailSubscription.length > 0 ? (
                              <div className="flex flex-wrap gap-2 px-3 py-2 bg-gray-100">
                                {data.oldEmailSubscription.split(',').map((item, i) => (
                                  <span key={i} className="px-2 py-1 text-xs bg-gray-200 rounded">
                                    {item.trim()}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <div className="flex flex-wrap px-3 py-4 bg-gray-100">-</div>
                            )}
                        </div>
                          
                        </div>
                      </div>
                    {/* NEW */}
                      <div>
                        <h4 className="font-semibold text-[#c00000] text-xl mb-4">Current Details</h4>
                        <div className="space-y-4">
                          <div>
                              <label className="flex text-sm font-medium mb-1">First Name</label>
                              <div className="flex">
                                <span className="border border-[#757575] border-r-0 px-4 py-3 bg-[#e9e9ea] text-[#757575] text-sm flex items-center whitespace-nowrap">
                                  {data.newTitle ? data.newTitle : '-'}
                                </span>
                                <div className="flex-1">
                                  <input
                                    disabled
                                    value={data.newFirstName ? data.newFirstName : '-'}
                                    className="w-full border border-[#757575] px-4 py-3 bg-[#e9e9ea] text-[#757575] text-sm"
                                  />
                                </div>
                              </div>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Last Name</label>
                            <input disabled value={data.newLastName? data.newLastName:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Email Address</label>
                            <input disabled value={data.newEmailAddress? data.newEmailAddress:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Bussiness Mobile</label>
                            <input disabled value={data.newBussinessMobile? data.newBussinessMobile :'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Office DID</label>
                            <input disabled value={data.newOfficeDID? data.newOfficeDID:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">Job Position</label>
                            <input disabled value={data.newDesignation? data.newDesignation:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                            <label className="block text-sm font-medium mb-1">Years Of Cumulative Experiences in Logistics Service </label>
                            <input disabled value={data.newExperienceYears? data.newExperienceYears:'-'} className="w-full border  px-3 py-2 bg-gray-100"/>
                          </div>
                          <div>
                              <label className="block text-sm font-medium mb-1">Subscribed to Email Circulars</label>
                              {data.newEmailSubscription && data.newEmailSubscription.length > 0 ? (
                                <div className="flex flex-wrap gap-2 border px-3 py-2 bg-gray-100">
                                  {data.newEmailSubscription.split(',').map((item, i) => (
                                    <span key={i} className="px-2 py-1 text-xs bg-gray-200 rounded">
                                      {item.trim()}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <div className="flex flex-wrap px-3 py-4 bg-gray-100">-</div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpgradeChangeRequestModal;